// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

import 'core-js';
import 'regenerator-runtime/runtime';
import $ from 'jquery';

import { Hero } from './components/hero';
import { Header } from './components/header';

import { MiniSlider } from './components/mini-slider';
import { HPLogoSlider } from './components/logo-slider';
import { HPPhotoGallery } from './components/photo-slider';
import { ReadMore } from './components/read-more';
import { LanguageSwitch } from './components/dropwdown-language';

import AOS from 'aos';


$(() => {
  new Header();
  new Hero();
  new LanguageSwitch();
  new MiniSlider();
  new HPLogoSlider();
  new HPPhotoGallery();
  new ReadMore();


  AOS.init({
    once: true
  });
  


  console.log('Welcome to Yeogurt!');

  window.addEventListener('load', function() {
    document.body.className = document.body.className.replace('preload', '');
  })
  window.addEventListener('resize', function() {
    AOS.refresh()
  })


});
